import logo from "../assets/unilogo.png";
import { Button } from "@mui/material";

const Login = () => {
    const url = process.env.REACT_APP_AD_URL;

    const handleLogin = () => {
        window.location.href = url;
    };
    return (
        <div className="login-container">
            <div className="row sign-in-box shadow-1">
                <div className="col-md-6 col-12 uni-logo-login">
                    <img
                        src={logo}
                        alt="logo"
                    />
                </div>
                <div className="col-md-6 col-12 sign-in-form">
                    <div className="sign-in-box pt-3">
                        <h2>Consumer Cloud</h2>
                        <Button
                            fullWidth
                            variant="contained"
                            color="primary"
                            onClick={handleLogin}
                        >
                            Sign in
                        </Button>
                        {/* <p>
              Please use the login provided below to access this application
            </p> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
